import './SocialIcon.css'
import Icon from './Icon'
import { audioEffects } from '../utils/audioEffects'

type IconName = 'sun' | 'moon' | 'github' | 'linkedin' | 'twitter' | 'email' | 'wom' | 'palette' | 'volume' | 'volumeMute' | 'settings' | 'spotify' | 'osrs' | 'instagram'

interface SocialIconProps {
  href: string
  title: string
  icon: IconName
  external?: boolean
}

function SocialIcon({ href, title, icon, external = true }: SocialIconProps) {
  const linkProps = external 
    ? { target: "_blank", rel: "noopener noreferrer" }
    : {}

  return (
    <a 
      href={href} 
      className="social-icon"
      title={title}
      onMouseEnter={() => audioEffects.playHover()}
      {...linkProps}
    >
      <Icon name={icon} />
    </a>
  )
}

export default SocialIcon